<template>
	<div class="qualifications-wrap">
		<!-- 精品推荐图片 -->
		<img class="title-img" src="../assets/index/qualifications-pc.png" alt="精品推荐图片" />
		<el-carousel :interval="4000" type="card" height="810px" style="margin-top: 20px;" indicator-position="none"
			:autoplay="false">
			<el-carousel-item v-for="(item,index) in 24" :key="item">
				<el-image :src="require('@/assets/index/swiper-'+(index+1)+'.png')"></el-image>
			</el-carousel-item>
			<!-- <Swiper v-for="(item, index) in 5" :key="index">
				<div class="imgBox">
					<el-image :src="require('@/assets/index/swiper-'+(index+1)+'.png')"></el-image>
				</div>
			</Swiper> -->
		</el-carousel>
	</div>

</template>

<script>
	import Swiper from "./swiper.vue"
	export default {
		components: {
			Swiper
		},
		data() {
			return {

			}
		},
		methods: {



		}
	}
</script>

<style lang="scss">
	.el-carousel__item .el-image {
		display: block;
		margin: 0 auto;
		width: 563px;
	}



	/* 响应式布局 */
	@media screen and (min-width: 1px) and (max-width: 768px) {
		.qualifications-wrap {
			width: 90%;
			margin: 0 auto;

			/* 设置精品文字图片外边距 */
			.introduce-img {
				margin-top: 10px;
				margin-bottom: 10px;

				/* 设置精品文字图片大小 */
				.title-img {
					width: 200px;
					height: auto;

				}
			}

			.qualifications-wrap-ul {
				margin-bottom: 20px;
				justify-content: space-between;

				li {
					flex-basis: 46%;
					padding-left: 10px;
					width: 170px;

					img.imgPC {
						width: 96%;
						height: auto;
					}

					h3 {
						/* text-align: center; */
						/* 根据浏览器宽度，文字大小动态改变 */
						font-size: 3vw;
						font-weight: 400;
						color: #121419;
						margin-bottom: 6px;
						margin-top: 6px;
					}

					p {
						/* text-align: center; */
						/* 根据浏览器宽度，文字大小动态改变 */
						font-size: 3vw;
						color: #ff6f00;

						span:nth-child(2) {
							text-decoration: line-through;
							/* 根据浏览器宽度，文字大小动态改变 */
							font-size: 2.4vw;
							color: #b9b9b9;
							margin-left: 4px;
						}
					}

					/* 第一排图片距离下面图片的间距 */
					&:nth-child(-n + 2) {
						margin-bottom: 10px;
					}

					/* 设置4的倍数产品图片的外边距 */
					&:nth-child(2n) {
						margin-right: 0;
					}
				}
			}
		}
	}

	@media screen and (min-width: 768px) and (max-width: 1023px) {
		.qualifications-wrap {
			width: 90%;
			margin: 0 auto;

			/* 设置精品文字图片外边距 */
			.introduce-img {
				margin-top: 10px;
				margin-bottom: 10px;

				/* 设置精品文字图片大小 */
				.title-img {
					width: 300px;
					height: auto;
				}
			}

			.qualifications-wrap-ul {
				margin-bottom: 20px;
				justify-content: space-between;

				li {
					flex-basis: 30%;
					padding-left: 10px;
					width: 170px;

					img.imgPC {
						width: 96%;
						height: auto;
					}

					h3 {
						/* text-align: center; */
						/* 根据浏览器宽度，文字大小动态改变，，文字大小动态改变 大小是p的30% */
						font-size: 2.4vw;
						font-weight: 400;
						color: #121419;
						margin-bottom: 6px;
						margin-top: 6px;
					}

					p {
						/* text-align: center; */
						/* 根据浏览器宽度，文字大小动态改变 */
						font-size: 3vw;
						color: #ff6f00;

						span:nth-child(2) {
							text-decoration: line-through;
							/* 根据浏览器宽度，文字大小动态改变，，文字大小动态改变 大小是p的30% */
							font-size: 2.4vw;
							color: #b9b9b9;
							margin-left: 4px;
						}
					}

					/* 第一排图片距离下面图片的间距 */
					&:nth-child(-n + 2) {
						margin-bottom: 10px;
					}

					/* 设置4的倍数产品图片的外边距 */
					&:nth-child(2n) {
						margin-right: 0;
					}
				}
			}
		}
	}

	@media screen and (min-width: 1024px) and (max-width: 1339px) {
		.qualifications-wrap {
			width: 90%;
			margin: 0 auto;

			/* 设置精品文字图片外边距 */
			.introduce-img {
				margin-top: 10px;
				margin-bottom: 10px;

				/* 设置精品文字图片大小 */
				.title-img {
					width: 300px;
					height: auto;
				}
			}

			.qualifications-wrap-ul {
				margin-bottom: 20px;
				justify-content: space-between;

				li {
					flex-basis: 30%;
					padding-left: 10px;
					width: 170px;

					img.imgPC {
						width: 96%;
						height: auto;
					}

					h3 {
						/* text-align: center; */
						/* 根据浏览器宽度，文字大小动态改变 大小是p的30% */
						font-size: 1.9vw;
						font-weight: 400;
						color: #121419;
						margin-bottom: 6px;
						margin-top: 6px;
					}

					p {
						/* text-align: center; */
						/* 根据浏览器宽度，文字大小动态改变 */
						font-size: 2.4vw;
						color: #ff6f00;

						span:nth-child(2) {
							text-decoration: line-through;
							/* 根据浏览器宽度，文字大小动态改变，文字大小动态改变 大小是p的30% */
							font-size: 1.9vw;
							color: #b9b9b9;
							margin-left: 4px;
						}
					}

					/* 第一排图片距离下面图片的间距 */
					&:nth-child(-n + 2) {
						margin-bottom: 10px;
					}

					/* 设置2的倍数产品图片的外边距 */
					&:nth-child(2n) {
						margin-right: 0;
					}
				}
			}
		}
	}

	@media screen and (min-width: 1400px) {
		.qualifications-wrap {
			/* 设置产品图片父元素宽度 */
			max-width: 1400px;
			margin: 40px auto 0;

			.introduce-img {
				/* 设置精品文字图片外边距 */

				margin-bottom: 31px;

				/* 设置精品文字图片大小 */
				.title-img {
					width: 337px;
					height: auto;
				}
			}

			.qualifications-wrap-ul {
				margin: 0 auto;

				li {
					padding: 2px;
					margin-right: 14px;
					border: 1px solid transparent;

					&:hover {
						border: 1px solid #2b80ff;
					}

					width: 332px;

					h3 {
						/* text-align: center; */
						font-size: 24px;
						font-weight: 400;
						color: #121419;
						margin-bottom: 14px;
						margin-top: 14px;
					}

					p {
						/* text-align: center; */
						font-size: 30px;
						color: #ff6f00;

						span:nth-child(2) {
							text-decoration: line-through;
							font-size: 24px;
							color: #b9b9b9;
							margin-left: 4px;
						}
					}

					/* 第一排图片距离下面图片的间距 */
					&:nth-child(-n + 4) {
						margin-bottom: 20px;
					}

					/* 设置4的倍数产品图片的外边距 */
					&:nth-child(4n) {
						margin-right: 0;
					}
				}
			}
		}
	}
</style>